import { useState } from 'react';
import GeckoAuthService from '../../services/gecko-auth';

function useProgressFileUpload({
  uploadURL,
  requestHeaders,
  formDataKey = 'files',
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const startUpload = async (files) => {
    return new Promise((resolve, reject) => {
      const formData = [...files].reduce((formData, file) => {
        formData.append(formDataKey, file);
        return formData;
      }, new FormData());

      setIsUploading(true);
      setUploadProgress(0);

      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        setIsUploading(false);
        return xhr.status === 200
          ? resolve(xhr.responseText)
          : reject(xhr.responseText);
      };
      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable) {
          return;
        }
        setUploadProgress((event.loaded / event.total) * 100);
      };
      xhr.upload.onloadend = () => {
        setUploadProgress(100);
      };
      xhr.onerror = (error) => {
        setUploadProgress(0);
        setIsUploading(false);
        reject(error);
      };
      xhr.open('POST', uploadURL);
      GeckoAuthService.getToken().then((token) => {
        Object.entries({ ...requestHeaders, Authorization: token })
          .filter(([name, _value]) => name !== 'Content-Type')
          .forEach(([name, value]) => xhr.setRequestHeader(name, value));
        xhr.send(formData);
      });
    });
  };

  return { isUploading, uploadProgress, startUpload };
}

export default useProgressFileUpload;
